import { useOnline as useOnlineOf } from "@thekrystalship/auth-client/react";
import { connectivity } from "../lib/connectivity.js";

/** Whether the panel reaches its entry node (`lib/connectivity.js`): what the shell powers places and the page down by. */
export const useOnline = () => useOnlineOf(connectivity);
